import React, { useState, useEffect, MouseEvent } from "react";
import Form from "react-bootstrap/Form";
import Container from "react-bootstrap/Container";
import Button from "react-bootstrap/Button";
import { signUp } from "../../store/user/actions";
import { selectToken } from "../../store/user/selectors";
import { useDispatch, useSelector } from "react-redux";
import { useHistory, Link } from "react-router-dom";
import { Col } from "react-bootstrap";

export default function SignUp() {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [height, set_height] = useState("");
  const [weight, set_weight] = useState("");
  const [gender, set_gender] = useState("");
  const dispatch = useDispatch();
  const token = useSelector(selectToken);
  const history = useHistory();

  useEffect(() => {
    if (token !== null) {
      history.push("/");
    }
  }, [token, history]);

  function submitForm(event: MouseEvent) {
    event.preventDefault();

    dispatch(signUp(name, email, password, height, weight, gender));

    setEmail("");
    setPassword("");
    setName("");
  }

  return (
    <Container>
      <Form as={Col} md={{ span: 6, offset: 3 }} className="mt-5">
        <h1 className="mt-5 mb-5">Signup</h1>
        <Form.Group controlId="formBasicName">
          <Form.Label>Name:</Form.Label>
          <Form.Control
            value={name}
            onChange={(event) => setName(event.target.value)}
            type="text"
            placeholder="Enter name"
            required
          />
        </Form.Group>
        <Form.Group controlId="formBasicEmail">
          <Form.Label>E-mail:</Form.Label>
          <Form.Control
            value={email}
            onChange={(event) => setEmail(event.target.value)}
            type="email"
            placeholder="Enter email"
            required
          />
        </Form.Group>

        <Form.Group controlId="formBasicPassword">
          <Form.Label>Password:</Form.Label>
          <Form.Control
            value={password}
            onChange={(event) => setPassword(event.target.value)}
            type="password"
            placeholder="Password"
            required
          />
        </Form.Group>
        <Form.Group style={{ display: "flex" }} controlId="formBasicDimensions">
          <div style={{ width: "50%" }}>
            <Form.Label>Height (in cm):</Form.Label>
            <Form.Control
              value={height}
              onChange={(event) => set_height(event.target.value)}
              type="text"
              placeholder="Height"
              required
            />
          </div>
          <div style={{ width: "50%" }}>
            <Form.Label>Weight (in kg):</Form.Label>
            <Form.Control
              value={weight}
              onChange={(event) => set_weight(event.target.value)}
              type="text"
              placeholder="Weight"
              required
            />
          </div>
        </Form.Group>
        <Form.Group controlId="formBasicEmail">
          <Form.Label>Gender:</Form.Label>
          <Form.Control
            onChange={(event) => set_gender(event.target.value)}
            as="select"
          >
            <option>Male</option>
            <option>Female</option>
            <option>Other</option>
          </Form.Control>
        </Form.Group>
        <Form.Text className="text-muted">
          Any information collected from our users will not be sold, shared, or
          rented to others.
        </Form.Text>
        <Form.Group className="mt-5">
          <Button variant="primary" type="submit" onClick={submitForm}>
            Sign up
          </Button>
        </Form.Group>

        <Link to="/login">Click here to log in</Link>
      </Form>
    </Container>
  );
}
